import moment from "moment-timezone";
import { dateFormat } from "src/utils/constants";
import {
  communication,
  communications,
  SendTime,
  SendType,
} from "types/code-generator";

interface Props {
  communication:
    | communication["communication"]
    | communications["communications"][0];
  className?: string;
}

export function CommunicationSummary(props: Props) {
  let summary = [];

  if (props.communication.sendType === SendType.Scheduled) {
    summary.push(
      `Sends ${moment(props.communication.date).format(dateFormat)} to`
    );
  } else if (props.communication.sendType === SendType.Custom) {
    const sendTime = props.communication.sendTime;

    if (sendTime === SendTime.Registration) {
      summary.push("Sends at registration to ");
    } else {
      if (sendTime === SendTime.CheckIn) {
        summary.push(`Sends`);
      } else {
        summary.push(
          `Sends ${
            props.communication.ruleAmount
          } ${props.communication.ruleAmountType.toLowerCase()}${
            props.communication.ruleAmount !== 1 ? "s" : ""
          }`
        );
      }

      if (sendTime === SendTime.AfterRegistration) {
        summary.push(`after registration to`);
      } else if (sendTime === SendTime.BeforeStart) {
        summary.push(`before the first start time to`);
      } else if (sendTime === SendTime.BeforeEnd) {
        summary.push(`before the final end time to`);
      } else if (sendTime === SendTime.AfterStart) {
        summary.push(`after the first start time to`);
      } else if (sendTime === SendTime.AfterEnd) {
        summary.push(`after the final end time to`);
      } else if (sendTime === SendTime.BeforeInstance) {
        summary.push(
          `before the instance start time to enrolled or checked-in accounts`
        );
      } else if (sendTime === SendTime.CheckIn) {
        summary.push(`at check-in`);
      }
    }
  }

  summary = summary.concat(props.communication.recipientTypes.join(", "));

  return <div className={props.className}>{summary.join(" ")}</div>;
}
